import { Route } from "react-router";
import React from "react";
import { store } from "@store";
import { NodeRefFragment } from "@graphql";
import { nodeGetTypeAndId } from "@clientUtils";
import { CONSULTANT_SLIDER, CUSTOMER_SLIDER } from "@navigation";
import { ConsultantProfileLocation } from "@navigation/locations/consultant-profile.location";
import { CustomerProfileLocation } from "@navigation/locations/CustomerProfileLocation";

export const getParentRoute = (path: string) => path.slice(0, path.lastIndexOf("/"));

export const getRootRoute = (path: string) => {
  const rootPath = path.split("/")[1];
  return path.slice(0, path.indexOf(rootPath) + rootPath.length);
};

const getPathNameFromStore = (): string => {
  const {
    routing: {
      history: {
        location: { pathname }
      }
    }
  } = store();
  return pathname;
};

export const getBaseRouteFromCurrentUrl = () => {
  return getRootRoute(getPathNameFromStore());
};

export function pushToNodeItem(nodeRef: NodeRefFragment) {
  const { type, id } = nodeGetTypeAndId(nodeRef);
  const {
    history,
    location: { pathname }
  } = store().routing;

  switch (type) {
    case "customer":
      store().navigation.open(CUSTOMER_SLIDER, new CustomerProfileLocation(id));
      break;
    case "consultant":
      store().navigation.open(CONSULTANT_SLIDER, new ConsultantProfileLocation(id));
      break;
    case "user":
      break;
    default:
      history.push(`${pathname}/${type}/${id}`);
      break;
  }
}

let hasWorked = false;

export function checkIfDirectRoute(
  path: string[] | string,
  flowName: string,
  mapParamsToLocation: (any) => any
) {
  if (hasWorked) {
    return null;
  }

  hasWorked = true;

  return (
    <Route path={path as any}>
      {(props) => {
        const { match } = props;

        if (!match || !match.params) {
          return null;
        }

        const { navigation } = store();

        if (
          navigation.hasInstance(flowName) &&
          !!navigation.getInstance(flowName).location
        ) {
          return null;
        }

        const baseURl = getBaseRouteFromCurrentUrl();
        navigation.open(flowName, mapParamsToLocation(match.params), baseURl);

        return null;
      }}
    </Route>
  );
}
